import React from 'react';

const MenuButton = (props) => {
    const { direction, radio } = props;
    return (
        <button
            type="button"
            className={'btn_tel_fleche btn_fleche_' + direction + '_menu'}
            id={'btn_menu_' + direction}
            onClick={() => radio.pressButton(direction)}
        >
            <img src={'/images/icons/radio/' + direction + '.svg'} />
        </button>
    );
};

export default MenuButton;
